import { Flex, Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import paletteIcon from 'img/palette.svg';
import TraitsGallery from 'components/TraitsGallery';
import { FUTURA_PALETTES, TRAITS_MEDIA_FILES } from '../../constants';
import RoundedBox from 'components/Traits/RoundedBox';

interface ColorPaletteProps {}

const ColorPalette: React.FC<ColorPaletteProps> = () => {
  return (
    <Row>
      <Col xs={12} sm={12} md={5}>
        <RoundedBox>
          <TraitsGallery
            items={FUTURA_PALETTES.map(p => ({
              title: p.name,
              content: (
                <Box>
                  <img
                    src={TRAITS_MEDIA_FILES.palettes[p.name]}
                    width="100%"
                    alt={p.name}
                  />
                </Box>
              ),
              description: p.description,
            }))}
          />
        </RoundedBox>
      </Col>

      <Col id="palettes" xs={12} sm={12} md={7}>
        <RoundedBox minHeight="570px">
          <Flex mb={3}>
            <img src={paletteIcon} width="20px" alt="palette icon" />
            <Box ml={3} fontWeight="bold" fontSize={3}>
              Color Palettes
            </Box>
          </Flex>
          <Box>
            <ul>
              <li>
                The color palette is a global trait, with each song having a predefined color
                palette. With one color per layer, each Clip of that layer will use a slightly
                different hue of that specific color. The Futura NFT adopts the more predominant
                Color Palette among its Clips.
              </li>
              <li>The band color will be a random color with low opacity.</li>
              <li>
                The background color will be a random color with decreased saturation and increased
                lightness.
              </li>
              <li>
                When two pieces are mixed, the Futura Remix NFT adopts the more predominant Color
                Palette among its clips, meaning that the remixer will have some control over what
                color palette the remix will have depending on which clips it picks.
              </li>
            </ul>
          </Box>
        </RoundedBox>
      </Col>
    </Row>
  );
};

export default ColorPalette;
